import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SmoothScroll from "./components/SmoothScroll";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import Programs from "./pages/Programs";
import About from "./pages/About";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

export default function App() {
    return (
        <ErrorBoundary>
            <SmoothScroll>
                <BrowserRouter>
                    <ScrollToTop />
                    <div className="min-h-screen bg-paper font-body text-ink">
                        <Navbar />
                        <main>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/programs" element={<Programs />} />
                                <Route path="/about" element={<About />} />
                                <Route path="*" element={<Home />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                </BrowserRouter>
            </SmoothScroll>
        </ErrorBoundary>
    );
}
